import flatten from 'flat';
import account from './en-US/account';
import organization from './en-US/organization';

export default flatten({
  ...account,
  ...organization,
});
